export default "__VITE_ASSET__6619b010__"